import { createEditorValue } from '@gitbook/doc-core';
import { type DocumentJSON, deserialize } from '@gitbook/slate';
import { Editor } from '@gitbook/slate-react';

import { ContentEditorContext, ContentEditorDefaultContext } from '../contexts';
import { mainPlugin } from '../renderer';

export function OpenAPIDocumentRenderer(props: { document: DocumentJSON }) {
    const { document } = props;
    const value = createEditorValue(deserialize(document));
    return (
        <ContentEditorContext.Provider value={ContentEditorDefaultContext}>
            <Editor value={value} readOnly onChange={() => {}} plugins={[mainPlugin]} />
        </ContentEditorContext.Provider>
    );
}
